const priorityEnum = {
  immediate: 'Immediate',
  investigation: 'Investigation',
};

export default priorityEnum;
